export default __webpack_public_path__ + "static/rajasthan-bike-tour-23-b07c7b03b076e98e4b5121c294de0d06.jpg";